import { render, staticRenderFns } from "./SearchedContentsCarousel.vue?vue&type=template&id=636d8b33&scoped=true"
import script from "./SearchedContentsCarousel.vue?vue&type=script&lang=js"
export * from "./SearchedContentsCarousel.vue?vue&type=script&lang=js"
import style0 from "./SearchedContentsCarousel.vue?vue&type=style&index=0&id=636d8b33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d8b33",
  null
  
)

export default component.exports